import {
  apiActionBuilder,
  apiRequestPayloadBuilder,
  ApiRequestPayloadBuilderOptions,
  ApiSuccessAction,
  HttpMethod,
} from "../api-builder";
import { IEvent } from "models/Event";

export interface PatchMerchantsEventsByMerchantIdAndEventIdParams {
  merchantId: string;
  eventId: string;
  title?: string;
  content?: string;
  imageUri?: string;
  validFrom: string;
  expire: string;
}

export interface PatchMerchantsEventsByMerchantIdAndEventIdResponseData {
  event: IEvent;
}

export default apiActionBuilder<
  PatchMerchantsEventsByMerchantIdAndEventIdParams,
  ApiSuccessAction<PatchMerchantsEventsByMerchantIdAndEventIdResponseData>
>(
  "apis/merchants/{merchantId}/events/{eventId}/patch",
  (
    params: PatchMerchantsEventsByMerchantIdAndEventIdParams,
    options?: ApiRequestPayloadBuilderOptions,
  ) => ({
    payload: apiRequestPayloadBuilder(
      {
        path: `/merchants/${params.merchantId}/events/${params.eventId}`,
        method: HttpMethod.PATCH,
        body: {
          title: params.title,
          content: params.content,
          imageUri: params.imageUri,
          validFrom: params.validFrom,
          expire: params.expire,
        },
      },
      options,
      params,
    ),
  }),
);
